import type { StateTenant } from './types'

/**
 * Demo tenant overlays. In production these come from a CMS or admin panel;
 * for the NASAA demo we hardcode 1-2 examples that show how a paid sponsor
 * customizes the look and reporting routes of a state page.
 *
 * Lookup is keyed by `?tenant=<id>` on any /states/<slug> route.
 */
const TENANTS: Record<string, StateTenant> = {
  'md-treasury': {
    id: 'md-treasury',
    brandName: 'Maryland Office of the State Treasurer',
    tagline: 'A consumer-protection initiative for Maryland residents.',
    primaryColor: '#b71234', // Maryland flag red
    logoUrl:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Seal_of_Maryland.svg/200px-Seal_of_Maryland.svg.png',
    attributionMode: 'co-branded',
    hotline: {
      name: 'Maryland Consumer Protection Hotline',
      phone: '1-888-743-0023',
      description: 'Free help if you suspect a scam targeting a Maryland resident.',
      url: 'https://www.marylandattorneygeneral.gov/Pages/CPD/default.aspx',
    },
    sponsorStrip: {
      label: 'In partnership with the Maryland Office of the State Treasurer',
    },
  },
  'demo-credit-union': {
    id: 'demo-credit-union',
    brandName: 'Atlantic Federal Credit Union',
    tagline: 'Fraud protection for our members and their families.',
    primaryColor: '#0e6b5c',
    attributionMode: 'powered-by',
    hotline: {
      name: 'Atlantic Federal Member Fraud Line',
      phone: '1-800-555-0119',
      description: 'Available 24/7 for members who suspect a fraudulent transaction.',
    },
    sponsorStrip: {
      label: 'Sponsored by Atlantic Federal Credit Union',
    },
  },
  'demo-attorney-general': {
    id: 'demo-attorney-general',
    brandName: 'Office of the State Attorney General',
    tagline: 'A consumer-protection initiative for residents.',
    primaryColor: '#1d4ed8',
    attributionMode: 'co-branded',
    hotline: {
      name: 'Consumer Protection Hotline',
      phone: '1-800-422-7128',
      description: 'Free help for residents who suspect a scam or want to report fraud.',
    },
    sponsorStrip: {
      label: 'In partnership with the Office of the State Attorney General',
    },
  },
}

export function getTenant(id: string | undefined | null): StateTenant | null {
  if (!id) return null
  return TENANTS[id.toLowerCase()] ?? null
}

export function listTenants(): StateTenant[] {
  return Object.values(TENANTS)
}
